import { categoryEstimationConfig } from "sj-ui-toolkit/src/atlas/utils/kaConstants";

function getOutstandingAssessments(assessments) {
  return assessments
    .filter(item => item.content?.knowledgeAssessment?.status?.progress !== "Completed")
    .sort((a, b) => {
      const isAInProgress = a.content?.knowledgeAssessment?.status?.progress === "InProgress";
      const isBInProgress = b.content?.knowledgeAssessment?.status?.progress === "InProgress";
      return Number(isBInProgress) - Number(isAInProgress); // Leverages boolean to number coercion
    });
}

function calculateDueDate(scheduleObj) {
  const { availableAt, dueAfter } = scheduleObj;

  const startDate = new Date(availableAt);
  startDate.setDate(startDate.getDate() + dueAfter.days);

  return startDate.toISOString();
}

// SHRPA-2566: This endpoint will change before release, we need to update the hardcoded values when they're ready
export function formatAssessmentData(filteredAssessments) {
  let outstandingAssessments = getOutstandingAssessments(filteredAssessments);
  return outstandingAssessments.map(assessment => {
    // calculate estimated time based on each category/section (e.g. topicPrefix)
    const sections = assessment.content.knowledgeAssessment.configuration.filters.sections;
    let estimatedTime = [0, 0]; // [min, max] in minutes
    sections.forEach(section => {
      const sectionEstimation = categoryEstimationConfig[section];
      if (sectionEstimation) {
        const min = parseInt(sectionEstimation.estFinishTime.split(" - ")[0]);
        const max = parseInt(sectionEstimation.estFinishTime.split(" - ")[1]);
        estimatedTime[0] += min;
        estimatedTime[1] += max;
      }
    });
    return {
      id: assessment.assignmentTaskUuid,
      type: "Assessment",
      status: assessment.content.knowledgeAssessment.status.progress,
      title: assessment.listing.title,
      description: assessment.listing.description,
      dueDate: calculateDueDate(assessment.schedule.dates),
      points: 200, // TODO: need this data from API
      questions: 20, // TODO: need this data from API
      estimatedTime: `${estimatedTime[0]} - ${estimatedTime[1]}`,
      locked: false, // Unclear if we need this anymore with assignmentTaskUuid
      assignmentUUID: assessment.assignment.uuid,
    };
  });
}
